import {css} from 'styled-components'

export const mobile = (props) => {
   return css`
   @media only screen and (min-width:360px) and (max-width:480px){
    ${props}
   }
   ` 
}

export const tablet = (props) => {
   return css`
   @media only screen and (min-width:768px) and (max-width:1280px){
    ${props}
   }
   ` 
}
